import { Outlet } from 'react-router-dom';

/**
 * Passthrough layout for /for-producers/* routes.
 * Both signed-out and logged-in users use the same qualify wizard.
 * Logged-in users get email prefilled and user linking at submit time.
 */
export function AuthedForProducersRedirect() {
  return <Outlet />;
}
